export default "__VITE_ASSET__88e8cfb4__"